/**
 * Parcel-spezifische API-Funktionen (Flurstücke)
 * Nested unter Area-Ressource
 */
import { api } from './client';

export const parcelsApi = {
  async getParcels(projectId: string): Promise<any[]> {
    return api.get(`/projects/${projectId}/area/parcels`);
  },

  async getParcel(projectId: string, parcelId: string): Promise<any> {
    return api.get(`/projects/${projectId}/area/parcels/${parcelId}`);
  },

  async updateParcel(
    projectId: string,
    parcelId: string,
    updateData: { status?: string; notizen?: string; eigentuemer?: string }
  ): Promise<any> {
    return api.patch(`/projects/${projectId}/area/parcels/${parcelId}`, updateData);
  },

  async updateParcelStatus(projectId: string, parcelId: string, status: string): Promise<any> {
    return api.patch(`/projects/${projectId}/area/parcels/${parcelId}`, { status });
  },

  async updateParcelNotes(projectId: string, parcelId: string, notizen: string): Promise<any> {
    return api.patch(`/projects/${projectId}/area/parcels/${parcelId}`, { notizen: notizen || undefined });
  },
};

